import { Card } from 'antd';
import type { CardProps } from 'antd';
import React from 'react';

/** Layout slots for the shared note-card chrome used across Crepe/Milkdown editor flows. */
export type NoteCardEditorShellProps = {
  /** Passed through to the Ant Card (Create Note session correlation). */
  dataAssetSessionId?: string;
  cardProps?: CardProps;
  titleRow: React.ReactNode;
  tagRow?: React.ReactNode;
  /** Inserted between tags and tip row (e.g. alerts, description field). */
  betweenTagsAndTip?: React.ReactNode;
  tipRow?: React.ReactNode;
  editorRegion: React.ReactNode;
  footer?: React.ReactNode;
};

/**
 * Shared “note card” chrome: Crepe/Milkdown flows reuse the same Ant Card layout as Create Note.
 */
export const NoteCardEditorShell: React.FC<NoteCardEditorShellProps> = ({
  dataAssetSessionId,
  cardProps,
  titleRow,
  tagRow,
  betweenTagsAndTip,
  tipRow,
  editorRegion,
  footer,
}) => (
  <Card
    data-asset-session-id={dataAssetSessionId}
    className="create-note-page__card"
    {...cardProps}
  >
    <div className="create-note-page__content">
      <div className="create-note-page__fixed-header">{titleRow}</div>
      <div className="create-note-page__scroll-body">
        {tagRow}
        {betweenTagsAndTip}
        {tipRow}
        {editorRegion}
      </div>
      <div className="create-note-page__fixed-footer">{footer}</div>
    </div>
  </Card>
);
